import { useState } from "react";
import { SudoButton } from "src/sudokit/components/SudoButton";
import Auth from "../../../Auth";
import { CompletionsSearchInput, Container } from "./styles";

export default function CompletionsSearch({ user }) {
  const [invocations, setInvocations] = useState([]);
  const [search, setSearch] = useState("");
  const [searching, setSearching] = useState(false);

  return (
    <Container>
      <h3 className="text-base font-medium mb-4">Search Completions</h3>

      <form
        onSubmit={(e) => {
          e.preventDefault();

          setSearching(true);
          Auth.fetchWithIdToken(`/api/admin/completions/search`, {
            user_id: user.uid,
            search,
          }).then((res) => {
            setSearching(false);
            setInvocations(res.invocations);
          });
        }}
        className="flex gap-2 mb-4"
      >
        <CompletionsSearchInput
          type="text"
          onChange={(e) => setSearch(e.target.value)}
          value={search}
          placeholder="Search term..."
          className="flex-1 px-3 py-2 border border-gray-300 rounded-md text-sm"
        />
        <SudoButton
          type="submit"
          variant="primary"
          size="default"
          state={searching ? "loading" : "default"}
          disabled={searching}
        >
          {searching ? "Searching..." : "Search"}
        </SudoButton>
      </form>

      <ul className="invocations space-y-3">
        {invocations.map((invocation) => {
          return (
            <li
              key={invocation.id}
              className="invocation bg-gray-50 p-4 rounded-lg"
            >
              <div className="mb-2">
                <a
                  href={`/admin/invocation/${invocation.id}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-app-primary-cta hover:text-app-primary-cta-dark hover:underline font-mono text-sm"
                >
                  {invocation.id}
                </a>
                <span className="text-gray-600 text-sm ml-2">
                  {invocation.source} - {invocation.createdAt}
                </span>
              </div>
              <ul className="snippets space-y-1">
                {invocation.snippets.map((snippet, index) => {
                  return (
                    <li
                      key={index}
                      className="text-sm text-gray-700 italic pl-4 border-l-2 border-gray-200"
                    >
                      ... {snippet} ...
                    </li>
                  );
                })}
              </ul>
            </li>
          );
        })}
      </ul>
    </Container>
  );
}
